import { features } from "./featuresStore";
import { Feature, FeatureConfig } from "./interfaces";

const CALL_DISABLED_FEATURE = "equipenine/CALL_DISABLE_FEATURE";

const overrideValues = <T>(
  object: Record<string, T>,
  overrideFunction: (key: string) => T
): Record<string, T> => {
  const newObject: Record<string, T> = {};
  Object.keys(object).forEach((key) => {
    newObject[key] = overrideFunction(key);
  });
  return newObject;
};

export const registerFeature = ({
  name,
  module
}: FeatureConfig & { module: Feature<any> }): void => {
  if (name in features) {
    throw new Error(`Feature "${name}" already registered`);
  }

  const isEnabled = module.enabled !== false;

  if (isEnabled) {
    features[name] = module;
  } else {
    const { reducer, actions, selectors, pages } = module;
    console.log(reducer, actions, selectors, pages);

    features[name] = {
      enabled: false,
      selectors,
      reducer: reducer ? () => ({}) : undefined,
      actions: actions
        ? (overrideValues(actions, (key) => () => {
            console.info(`Action ${key} disabled for feature "${name}"`);
            return { type: CALL_DISABLED_FEATURE };
          }) as any)
        : undefined,
      pages: pages
        ? overrideValues(pages, (key) => {
            console.info(`Page ${key} disabled for feature "${name}"`);
            return () => null;
          })
        : undefined
    };
  }
};
